import { render, staticRenderFns } from "./AttendanceTransfer.vue?vue&type=template&id=36c98d33&scoped=true"
import script from "./AttendanceTransfer.vue?vue&type=script&lang=js"
export * from "./AttendanceTransfer.vue?vue&type=script&lang=js"
import style0 from "./AttendanceTransfer.vue?vue&type=style&index=0&id=36c98d33&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c98d33",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTooltip,QIcon,QItemLabel,QItem,QItemSection,QSeparator});qInstall(component, 'directives', {Ripple});
